import { API } from "apis";
import Tag from "components/common/chip/Tag";
import Image from "components/common/images/Image";
import CorpDetailMap from "components/corp/detail/CorpDetailMap";
import CorpDetailSaleItems from "components/corp/detail/CorpDetailSaleItems";
import CorpDetailSideMenu from "components/corp/detail/CorpDetailSideMenu";
import { ContextModel, CorpDetailModel } from "models";
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useOutletContext, useParams } from "react-router-dom";
import { Utils } from "utils";

const CorpDetailPage: React.FC = () => {
  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  const params = useParams();
  const corp_id = params.id ?? "";

  const [data, setData] = React.useState<CorpDetailModel>();

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    const f = async () => {
      ctx.loading.setState(true);

      await ctx.auth.initialize();

      try {
        const response = await API.Corp.detail(corp_id);
        console.log(response);
        setData(response.data);
      } catch (err) {
        Utils.errorAction(ctx, err);
      }
      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) {
    return <></>;
  }

  return (
    <div className="flex h-full">
      <Helmet>
        <title>会社詳細</title>
      </Helmet>
      <div className="w-80 bg-slate-200 border-r h-full">
        <CorpDetailSideMenu showButtons={!ctx.auth.data?.is_admin_corp && ctx.auth.data?.corp_id !== data.corp_id} ctx={ctx} corp={data} />
        <div className="p-4">
          <div className="text-xl font-bold">タグ</div>
          <div className="flex flex-wrap gap-1">
            {data.corp_tag.map((tag, index) => {
              return (
                <Link key={index} to={`/company-list/?keyword=${tag.corp_tag_name}&get_count=10`}>
                  <Tag text={tag.corp_tag_name} maxWidth={"18rem"} />
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      <div className="p-4 flex-1">
        {data.corp_image && data.corp_image?.image_url && (
          <div className="flex justify-start">
            <Image data={data.corp_image} height="300px" />
          </div>
        )}
        {data.catch_phrase && <h2 className="border-b font-bold mt-8 text-2xl whitespace-pre-line break-all">{data.catch_phrase}</h2>}
        {data.introduction && <div className="p-4 whitespace-pre-line break-all">{data.introduction}</div>}
        {Utils.hasFile(data.pr_image_1) && (
          <div className="py-4 flex gap-4">
            <Image data={data.pr_image_1} height="200px" />
            <div className="flex-1 whitespace-pre-line break-all">{data.pr_image_text_1}</div>
          </div>
        )}
        {Utils.hasFile(data.pr_image_2) && (
          <div className="py-4 flex gap-4">
            <Image data={data.pr_image_2} height="200px" />
            <div className="flex-1 whitespace-pre-line break-all">{data.pr_image_text_2}</div>
          </div>
        )}
        {Utils.hasFile(data.pr_image_3) && (
          <div className="py-4 flex gap-4">
            <Image data={data.pr_image_3} height="200px" />
            <div className="flex-1 whitespace-pre-line break-all">{data.pr_image_text_3}</div>
          </div>
        )}
        <div className="m-4 p-4 border border-jhk-blue rounded flex flex-col gap-4">
          <div className="flex font-bold items-end">
            <div className="w-3/12 text-xl whitespace-pre-line break-all line-clamp-1" title={data.corp_name}>
              {data.corp_name}
            </div>
            {data.corp_no && <div className="flex-1">法人番号: {data.corp_no}</div>}
          </div>
          <div className="flex">
            <div className="w-3/12">業種</div>
            <div className="flex-1">
              {data.industry_major_name} - {data.industry_middle_name}
            </div>
          </div>
          <div className="flex">
            <div className="w-3/12">設立</div>
            <div className="flex-1">{Utils.Date.format2(data.establishment_date)}</div>
          </div>
          <div className="flex">
            <div className="w-3/12">資本金</div>
            <div className="flex-1">{data.capital_name}</div>
          </div>
          <div className="flex">
            <div className="w-3/12">所在地</div>
            <div className="flex-1">
              {data.prefecture_name}
              {data.citytown}
              {data.address}
            </div>
          </div>
        </div>

        <CorpDetailMap data={data} />

        <CorpDetailSaleItems data={data} withMyItem={!ctx.auth.data?.is_admin_corp && corp_id === ctx.auth.data?.corp_id} />
      </div>
    </div>
  );
};
export default CorpDetailPage;
